import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, MessageCircle } from "lucide-react";

const INSTAGRAM_URL = "https://www.instagram.com/homelarauk/";

const NAV = [
  { label: "Home", path: "/" },
  { label: "Our Services", path: "/services" },
  { label: "About Us", path: "/about" },
  { label: "How It Works", path: "/how-it-works" },
  { label: "FAQ", path: "/faq" },
  { label: "Contact", path: "/contact" },
];

const LEGAL = [
  { label: "Privacy Policy", path: "/legal/privacy-policy" },
  { label: "Terms & Conditions", path: "/legal/terms-and-conditions" },
  { label: "Cookie Policy", path: "/legal/cookie-policy" },
  { label: "Cancellation Policy", path: "/legal/cancellation-policy" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-blue-midnight text-canvas">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 sm:py-20">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <p className="font-serif text-3xl font-semibold tracking-[0.12em]">HOMELARA</p>
            <p className="mt-4 text-sm leading-relaxed text-sage max-w-xs">
              Professional cleaning for homes, properties and businesses across London.
            </p>
            <p className="mt-6 font-serif text-lg italic text-canvas/80">
              A beautifully clean, cared-for home. More time for the life you love.
            </p>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="HOMELARA on Instagram"
              data-testid="footer-instagram-icon-link"
              className="mt-6 inline-flex h-10 w-10 items-center justify-center rounded-full border border-blue-border text-sage transition-colors hover:border-canvas hover:text-canvas"
            >
              <Instagram size={18} />
            </a>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-sage">Explore</p>
            <ul className="mt-5 space-y-3">
              {NAV.map((l) => (
                <li key={l.path}>
                  <Link
                    to={l.path}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm text-canvas/75 hover:text-canvas transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-sage">Contact</p>
            <ul className="mt-5 space-y-4 text-sm text-canvas/75">
              <li className="flex items-start gap-3">
                <Mail size={16} className="mt-0.5 shrink-0 text-sage" />
                <a href="mailto:lauraflorez@homelara.uk" data-testid="footer-email-link" className="hover:text-canvas transition-colors">
                  lauraflorez@homelara.uk
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MessageCircle size={16} className="mt-0.5 shrink-0 text-sage" />
                <a
                  href="https://wa.me/447939365873"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp-link"
                  className="hover:text-canvas transition-colors"
                >
                  +44 7939 365873
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 shrink-0 text-sage" />
                <span>London Zones 1 &amp; 2</span>
              </li>
              <li className="flex items-start gap-3">
                <Instagram size={16} className="mt-0.5 shrink-0 text-sage" />
                <a
                  href={INSTAGRAM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram-follow-link"
                  className="hover:text-canvas transition-colors"
                >
                  Follow us on Instagram
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-sage">Legal</p>
            <ul className="mt-5 space-y-3">
              {LEGAL.map((l) => (
                <li key={l.path}>
                  <Link
                    to={l.path}
                    data-testid={`footer-legal-${l.label.toLowerCase().replace(/[\s&]+/g, "-")}`}
                    className="text-sm text-canvas/75 hover:text-canvas transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-blue-border pt-8">
          <p className="text-xs text-canvas/50">&copy; {new Date().getFullYear()} HOMELARA LTD. All rights reserved.</p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-sage">
            Time &middot; Home &middot; Professional Care
          </p>
        </div>
      </div>
    </footer>
  );
}
